// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_style_home__2Dyk5","box":"Home_style_box__2CqS_","left":"Home_style_left__1Qu8V","right":"Home_style_right__1e_3p"};